import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AssignEmailCycleRPC } from "./assignEmailCycleRPC";

export class AssignEmailCycleRPCClientImpl extends AssignEmailCycleRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AssignEmailCycleRPC.Request): Promise<LeoRPCResult<AssignEmailCycleRPC.Response, AssignEmailCycleRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/AssignEmailCycle",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AssignEmailCycleRPC.ResponseDTO,
      AssignEmailCycleRPC.Errors.ErrorsDTO,
      AssignEmailCycleRPC.Response,
      AssignEmailCycleRPC.Errors.Errors
    >(
      response,
      "email-cycle/AssignEmailCycle",
      AssignEmailCycleRPC.Response.fromDTO,
      AssignEmailCycleRPC.Errors.fromDTO
    );
  }
}
